export enum BusinessPartnerPatientsManagementRoutes {
  List = '',
  Register = 'register',
  Details = ':patientId',
}
